// CLS is being wrapped to expose boring specific API,
// as well as abstract CLS is being used under the hood.
// Right now we are using cls-hooked, but may revert to
// classic continuation-local-storage

// const cls = require('continuation-local-storage');
const cls = require('cls-hooked');

module.exports = cls;
